import type { Language, TripDto } from '@posilka/shared';
import { useTranslation } from 'react-i18next';
import { useTripsSearch } from '@posilka/client/api/trips';
import { formatDateTime } from '@posilka/client/lib/time';
import { haptic } from '@/lib/telegram';

/**
 * "Shu yo'nalishda ketayotganlar": tanlansa buyurtma avval o'sha shafyorga taklif bo'lib boradi
 * (2 soat), rad etsa yoki javob bermasa — hammaga ochiladi.
 */
export function TripPicker({
  fromCityId,
  toCityId,
  value,
  onChange,
}: {
  fromCityId?: string;
  toCityId?: string;
  value?: string;
  onChange: (trip: TripDto | null) => void;
}) {
  const { t, i18n } = useTranslation();
  const lang = i18n.language as Language;
  const trips = useTripsSearch(fromCityId, toCityId);
  if (!trips.data?.length) return null;

  return (
    <div className="mt-4">
      <p className="mb-1 px-1 text-sm font-medium">🗓 {t('trips.onRoute')}</p>
      <p className="mb-2 px-1 text-xs text-hint">{t('trips.bookHint')}</p>
      <div className="space-y-2">
        {trips.data.map((trip) => {
          const selected = trip.id === value;
          return (
            <button
              key={trip.id}
              type="button"
              onClick={() => {
                haptic.tap();
                onChange(selected ? null : trip);
              }}
              className={`press w-full rounded-2xl px-4 py-3.5 text-left ${
                selected
                  ? 'border border-lime bg-lime font-semibold text-lime-ink'
                  : 'border border-line bg-surface'
              }`}
            >
              <div className="flex items-center justify-between gap-2">
                <span className="font-medium">
                  {trip.driver.firstName}
                  {trip.driver.rating.verified && ' ✅'}
                  {trip.driver.rating.average ? ` · ⭐ ${trip.driver.rating.average}` : ''}
                </span>
                <span className="shrink-0 text-sm">{formatDateTime(trip.departAt, lang)}</span>
              </div>
              <p className="text-sm opacity-75">
                {trip.driver.carModel}, {trip.driver.carColor} ·{' '}
                {t('trips.seatsLeft', { count: trip.seatsLeft })}
              </p>
              {trip.note && <p className="mt-0.5 text-sm opacity-75">“{trip.note}”</p>}
            </button>
          );
        })}
      </div>
    </div>
  );
}
